import { jwtDecode } from "jwt-decode";

export default function tokenValid(token) {
  const expiry = jwtDecode(token).exp
  const now = Date.now() / 1000;
  return now < expiry;
}
